import { BrandCaptionLowerThirdEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandCaptionLowerThirdSetEventDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandCaptionLowerThirdSetEventDTO.validationSchema(),
    BrandCaptionLowerThirdEntity
  );

  constructor(readonly data: RoomBrandCaptionLowerThirdSetEvent) {
    JsonSchemaValidator.assert(
      RoomBrandCaptionLowerThirdSetEventDTO.validation,
      data
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "caption"],
      properties: {
        roomId,
        caption: {
          instanceof: BrandCaptionLowerThirdEntity.name
        }
      }
    };
  }
}

interface RoomBrandCaptionLowerThirdSetEvent {
  roomId: RoomId;
  caption: BrandCaptionLowerThirdEntity;
}
